"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Predecessor = exports.Successor = exports.MaxValue = exports.MinValue = exports.Power = exports.Log = exports.Exp = exports.Ln = exports.Round = exports.Negate = exports.Abs = exports.Truncate = exports.Floor = exports.Ceiling = exports.Modulo = exports.TruncatedDivide = exports.Divide = exports.Multiply = exports.Subtract = exports.Add = void 0;
var expression_1 = require("./expression");
var MathUtil = __importStar(require("../util/math"));
var quantity_1 = require("../datatypes/quantity");
var uncertainty_1 = require("../datatypes/uncertainty");
var builder_1 = require("./builder");
var Add = /** @class */ (function (_super) {
    __extends(Add, _super);
    function Add(json) {
        return _super.call(this, json) || this;
    }
    Add.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args, sum;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args == null || args.some(function (x) { return x == null; })) {
                            return [2 /*return*/, null];
                        }
                        sum = args.reduce(function (x, y) {
                            if (x.isUncertainty && !y.isUncertainty) {
                                y = new uncertainty_1.Uncertainty(y, y);
                            }
                            else if (y.isUncertainty && !x.isUncertainty) {
                                x = new uncertainty_1.Uncertainty(x, x);
                            }
                            if (x.isQuantity || x.isDateTime || x.isDate || (x.isTime && x.isTime())) {
                                return (0, quantity_1.doAddition)(x, y);
                            }
                            else if (x.isUncertainty && y.isUncertainty) {
                                if (x.low.isQuantity ||
                                    x.low.isDateTime ||
                                    x.low.isDate ||
                                    (x.low.isTime && x.low.isTime())) {
                                    return new uncertainty_1.Uncertainty((0, quantity_1.doAddition)(x.low, y.low), (0, quantity_1.doAddition)(x.high, y.high));
                                }
                                else {
                                    return new uncertainty_1.Uncertainty(x.low + y.low, x.high + y.high);
                                }
                            }
                            else {
                                return x + y;
                            }
                        });
                        if (MathUtil.overflowsOrUnderflows(sum)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, sum];
                }
            });
        });
    };
    return Add;
}(expression_1.Expression));
exports.Add = Add;
var Subtract = /** @class */ (function (_super) {
    __extends(Subtract, _super);
    function Subtract(json) {
        return _super.call(this, json) || this;
    }
    Subtract.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args, difference;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args == null || args.some(function (x) { return x == null; })) {
                            return [2 /*return*/, null];
                        }
                        difference = args.reduce(function (x, y) {
                            if (x.isUncertainty && !y.isUncertainty) {
                                y = new uncertainty_1.Uncertainty(y, y);
                            }
                            else if (y.isUncertainty && !x.isUncertainty) {
                                x = new uncertainty_1.Uncertainty(x, x);
                            }
                            if (x.isQuantity || x.isDateTime || x.isDate) {
                                return (0, quantity_1.doSubtraction)(x, y);
                            }
                            else if (x.isUncertainty && y.isUncertainty) {
                                if (x.low.isQuantity || x.low.isDateTime || x.low.isDate) {
                                    return new uncertainty_1.Uncertainty((0, quantity_1.doSubtraction)(x.low, y.high), (0, quantity_1.doSubtraction)(x.high, y.low));
                                }
                                else {
                                    return new uncertainty_1.Uncertainty(x.low - y.high, x.high - y.low);
                                }
                            }
                            else {
                                return x - y;
                            }
                        });
                        if (MathUtil.overflowsOrUnderflows(difference)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, difference];
                }
            });
        });
    };
    return Subtract;
}(expression_1.Expression));
exports.Subtract = Subtract;
var Multiply = /** @class */ (function (_super) {
    __extends(Multiply, _super);
    function Multiply(json) {
        return _super.call(this, json) || this;
    }
    Multiply.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args, product;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args == null || args.some(function (x) { return x == null; })) {
                            return [2 /*return*/, null];
                        }
                        product = args.reduce(function (x, y) {
                            if (x.isUncertainty && !y.isUncertainty) {
                                y = new uncertainty_1.Uncertainty(y, y);
                            }
                            else if (y.isUncertainty && !x.isUncertainty) {
                                x = new uncertainty_1.Uncertainty(x, x);
                            }
                            if (x.isQuantity || y.isQuantity) {
                                return (0, quantity_1.doMultiplication)(x, y);
                            }
                            else if (x.isUncertainty && y.isUncertainty) {
                                if (x.low.isQuantity) {
                                    return new uncertainty_1.Uncertainty((0, quantity_1.doMultiplication)(x.low, y.low), (0, quantity_1.doMultiplication)(x.high, y.high));
                                }
                                else {
                                    return new uncertainty_1.Uncertainty(x.low * y.low, x.high * y.high);
                                }
                            }
                            else {
                                return x * y;
                            }
                        });
                        if (MathUtil.overflowsOrUnderflows(product)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, product];
                }
            });
        });
    };
    return Multiply;
}(expression_1.Expression));
exports.Multiply = Multiply;
var Divide = /** @class */ (function (_super) {
    __extends(Divide, _super);
    function Divide(json) {
        return _super.call(this, json) || this;
    }
    Divide.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args, quotient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args == null || args.some(function (x) { return x == null; })) {
                            return [2 /*return*/, null];
                        }
                        quotient = args.reduce(function (x, y) {
                            if (x.isUncertainty && !y.isUncertainty) {
                                y = new uncertainty_1.Uncertainty(y, y);
                            }
                            else if (y.isUncertainty && !x.isUncertainty) {
                                x = new uncertainty_1.Uncertainty(x, x);
                            }
                            if (x.isQuantity) {
                                return (0, quantity_1.doDivision)(x, y);
                            }
                            else if (x.isUncertainty && y.isUncertainty) {
                                if (x.low.isQuantity) {
                                    return new uncertainty_1.Uncertainty((0, quantity_1.doDivision)(x.low, y.high), (0, quantity_1.doDivision)(x.high, y.low));
                                }
                                else {
                                    return new uncertainty_1.Uncertainty(x.low / y.high, x.high / y.low);
                                }
                            }
                            else {
                                return x / y;
                            }
                        });
                        // Note, anything divided by 0 is Infinity in Javascript, which will be
                        // considered as overflow by this check.
                        if (MathUtil.overflowsOrUnderflows(quotient)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, quotient];
                }
            });
        });
    };
    return Divide;
}(expression_1.Expression));
exports.Divide = Divide;
var TruncatedDivide = /** @class */ (function (_super) {
    __extends(TruncatedDivide, _super);
    function TruncatedDivide(json) {
        return _super.call(this, json) || this;
    }
    TruncatedDivide.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args, quotient, truncatedQuotient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args == null || args.some(function (x) { return x == null; })) {
                            return [2 /*return*/, null];
                        }
                        quotient = args.reduce(function (x, y) { return x / y; });
                        truncatedQuotient = quotient >= 0 ? Math.floor(quotient) : Math.ceil(quotient);
                        if (MathUtil.overflowsOrUnderflows(truncatedQuotient)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, truncatedQuotient];
                }
            });
        });
    };
    return TruncatedDivide;
}(expression_1.Expression));
exports.TruncatedDivide = TruncatedDivide;
var Modulo = /** @class */ (function (_super) {
    __extends(Modulo, _super);
    function Modulo(json) {
        return _super.call(this, json) || this;
    }
    Modulo.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args, modulo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args == null || args.some(function (x) { return x == null; })) {
                            return [2 /*return*/, null];
                        }
                        modulo = args.reduce(function (x, y) { return x % y; });
                        return [2 /*return*/, MathUtil.decimalOrNull(modulo)];
                }
            });
        });
    };
    return Modulo;
}(expression_1.Expression));
exports.Modulo = Modulo;
var Ceiling = /** @class */ (function (_super) {
    __extends(Ceiling, _super);
    function Ceiling(json) {
        return _super.call(this, json) || this;
    }
    Ceiling.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, Math.ceil(arg)];
                }
            });
        });
    };
    return Ceiling;
}(expression_1.Expression));
exports.Ceiling = Ceiling;
var Floor = /** @class */ (function (_super) {
    __extends(Floor, _super);
    function Floor(json) {
        return _super.call(this, json) || this;
    }
    Floor.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, Math.floor(arg)];
                }
            });
        });
    };
    return Floor;
}(expression_1.Expression));
exports.Floor = Floor;
var Truncate = /** @class */ (function (_super) {
    __extends(Truncate, _super);
    function Truncate(json) {
        return _super.call(this, json) || this;
    }
    Truncate.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, arg >= 0 ? Math.floor(arg) : Math.ceil(arg)];
                }
            });
        });
    };
    return Truncate;
}(expression_1.Expression));
exports.Truncate = Truncate;
var Abs = /** @class */ (function (_super) {
    __extends(Abs, _super);
    function Abs(json) {
        return _super.call(this, json) || this;
    }
    Abs.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        else if (arg.isQuantity) {
                            return [2 /*return*/, new quantity_1.Quantity(Math.abs(arg.value), arg.unit)];
                        }
                        else {
                            return [2 /*return*/, Math.abs(arg)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Abs;
}(expression_1.Expression));
exports.Abs = Abs;
var Negate = /** @class */ (function (_super) {
    __extends(Negate, _super);
    function Negate(json) {
        return _super.call(this, json) || this;
    }
    Negate.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        else if (arg.isQuantity) {
                            return [2 /*return*/, new quantity_1.Quantity(arg.value * -1, arg.unit)];
                        }
                        else {
                            return [2 /*return*/, arg * -1];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Negate;
}(expression_1.Expression));
exports.Negate = Negate;
var Round = /** @class */ (function (_super) {
    __extends(Round, _super);
    function Round(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = (0, builder_1.build)(json.precision);
        return _this;
    }
    Round.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg, dec, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _b.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        if (!(this.precision != null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.precision.execute(ctx)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = 0;
                        _b.label = 4;
                    case 4:
                        dec = _a;
                        return [2 /*return*/, Math.round(arg * Math.pow(10, dec)) / Math.pow(10, dec)];
                }
            });
        });
    };
    return Round;
}(expression_1.Expression));
exports.Round = Round;
var Ln = /** @class */ (function (_super) {
    __extends(Ln, _super);
    function Ln(json) {
        return _super.call(this, json) || this;
    }
    Ln.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg, ln;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        ln = Math.log(arg);
                        return [2 /*return*/, MathUtil.decimalOrNull(ln)];
                }
            });
        });
    };
    return Ln;
}(expression_1.Expression));
exports.Ln = Ln;
var Exp = /** @class */ (function (_super) {
    __extends(Exp, _super);
    function Exp(json) {
        return _super.call(this, json) || this;
    }
    Exp.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg, power;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        power = Math.exp(arg);
                        if (MathUtil.overflowsOrUnderflows(power)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, power];
                }
            });
        });
    };
    return Exp;
}(expression_1.Expression));
exports.Exp = Exp;
var Log = /** @class */ (function (_super) {
    __extends(Log, _super);
    function Log(json) {
        return _super.call(this, json) || this;
    }
    Log.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args, log;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args == null || args.some(function (x) { return x == null; })) {
                            return [2 /*return*/, null];
                        }
                        log = args.reduce(function (x, y) { return Math.log(x) / Math.log(y); });
                        return [2 /*return*/, MathUtil.decimalOrNull(log)];
                }
            });
        });
    };
    return Log;
}(expression_1.Expression));
exports.Log = Log;
var Power = /** @class */ (function (_super) {
    __extends(Power, _super);
    function Power(json) {
        return _super.call(this, json) || this;
    }
    Power.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args, power;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args == null || args.some(function (x) { return x == null; })) {
                            return [2 /*return*/, null];
                        }
                        power = args.reduce(function (x, y) { return Math.pow(x, y); });
                        if (MathUtil.overflowsOrUnderflows(power)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, power];
                }
            });
        });
    };
    return Power;
}(expression_1.Expression));
exports.Power = Power;
var MinValue = /** @class */ (function (_super) {
    __extends(MinValue, _super);
    function MinValue(json) {
        var _this = _super.call(this, json) || this;
        _this.valueType = json.valueType;
        return _this;
    }
    MinValue.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var minDateTime;
            return __generator(this, function (_a) {
                if (MinValue.MIN_VALUES[this.valueType]) {
                    if (this.valueType === '{urn:hl7-org:elm-types:r1}DateTime') {
                        minDateTime = MinValue.MIN_VALUES[this.valueType].copy();
                        minDateTime.timezoneOffset = ctx.getTimezoneOffset();
                        return [2 /*return*/, minDateTime];
                    }
                    else {
                        return [2 /*return*/, MinValue.MIN_VALUES[this.valueType]];
                    }
                }
                else {
                    throw new Error("Minimum not supported for ".concat(this.valueType));
                }
                return [2 /*return*/];
            });
        });
    };
    MinValue.MIN_VALUES = {
        '{urn:hl7-org:elm-types:r1}Integer': MathUtil.MIN_INT_VALUE,
        '{urn:hl7-org:elm-types:r1}Decimal': MathUtil.MIN_FLOAT_VALUE,
        '{urn:hl7-org:elm-types:r1}DateTime': MathUtil.MIN_DATETIME_VALUE,
        '{urn:hl7-org:elm-types:r1}Date': MathUtil.MIN_DATE_VALUE,
        '{urn:hl7-org:elm-types:r1}Time': MathUtil.MIN_TIME_VALUE
    };
    return MinValue;
}(expression_1.Expression));
exports.MinValue = MinValue;
var MaxValue = /** @class */ (function (_super) {
    __extends(MaxValue, _super);
    function MaxValue(json) {
        var _this = _super.call(this, json) || this;
        _this.valueType = json.valueType;
        return _this;
    }
    MaxValue.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var maxDateTime;
            return __generator(this, function (_a) {
                if (MaxValue.MAX_VALUES[this.valueType] != null) {
                    if (this.valueType === '{urn:hl7-org:elm-types:r1}DateTime') {
                        maxDateTime = MaxValue.MAX_VALUES[this.valueType].copy();
                        maxDateTime.timezoneOffset = ctx.getTimezoneOffset();
                        return [2 /*return*/, maxDateTime];
                    }
                    else {
                        return [2 /*return*/, MaxValue.MAX_VALUES[this.valueType]];
                    }
                }
                else {
                    throw new Error("Maximum not supported for ".concat(this.valueType));
                }
                return [2 /*return*/];
            });
        });
    };
    MaxValue.MAX_VALUES = {
        '{urn:hl7-org:elm-types:r1}Integer': MathUtil.MAX_INT_VALUE,
        '{urn:hl7-org:elm-types:r1}Decimal': MathUtil.MAX_FLOAT_VALUE,
        '{urn:hl7-org:elm-types:r1}DateTime': MathUtil.MAX_DATETIME_VALUE,
        '{urn:hl7-org:elm-types:r1}Date': MathUtil.MAX_DATE_VALUE,
        '{urn:hl7-org:elm-types:r1}Time': MathUtil.MAX_TIME_VALUE
    };
    return MaxValue;
}(expression_1.Expression));
exports.MaxValue = MaxValue;
var Successor = /** @class */ (function (_super) {
    __extends(Successor, _super);
    function Successor(json) {
        return _super.call(this, json) || this;
    }
    Successor.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg, successor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        successor = null;
                        try {
                            // MathUtil.successor throws on overflow, and the exception is used in
                            // the logic for evaluating `meets`, so it can't be changed to just return null
                            successor = MathUtil.successor(arg);
                        }
                        catch (e) {
                            if (e instanceof MathUtil.OverFlowException) {
                                return [2 /*return*/, null];
                            }
                        }
                        if (MathUtil.overflowsOrUnderflows(successor)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, successor];
                }
            });
        });
    };
    return Successor;
}(expression_1.Expression));
exports.Successor = Successor;
var Predecessor = /** @class */ (function (_super) {
    __extends(Predecessor, _super);
    function Predecessor(json) {
        return _super.call(this, json) || this;
    }
    Predecessor.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg, predecessor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        predecessor = null;
                        try {
                            // MathUtil.predecessor throws on underflow, and the exception is used in
                            // the logic for evaluating `meets`, so it can't be changed to just return null
                            predecessor = MathUtil.predecessor(arg);
                        }
                        catch (e) {
                            if (e instanceof MathUtil.OverFlowException) {
                                return [2 /*return*/, null];
                            }
                        }
                        if (MathUtil.overflowsOrUnderflows(predecessor)) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, predecessor];
                }
            });
        });
    };
    return Predecessor;
}(expression_1.Expression));
exports.Predecessor = Predecessor;
//# sourceMappingURL=arithmetic.js.map